
import Vue from 'vue'
import {AppModule} from "@/store/modules/app";
import { Configuration as RestConfiguration, AssetApi } from '@/rest'
import { AssetsModule, AssetFile } from '@/store/modules/asset'

export class ContentPrice extends Vue {
  get currencySymbol() {
    if(AppModule.session.products && AppModule.session.products.length > 0 && AppModule.session.products[0].price) {
      if(AppModule.session.products[0].price.currency == "EUR") return "€"
      if(AppModule.session.products[0].price.currency == "USD") return "$"
      if(AppModule.session.products[0].price.currency == "GBP") return "£"
      if(AppModule.session.products[0].price.currency == "CHF") return "SFr. "
      return AppModule.session.products[0].price.currency
    }
    return ""
  }

  get currencyFilterOptions() {
    if(AppModule.session.products && AppModule.session.products.length > 0 && AppModule.session.products[0].price) {
      if(AppModule.session.products[0].price.currency == "EUR") return {thousandsSeparator: '.',decimalSeparator: ',', symbolOnLeft: false, spaceBetweenAmountAndSymbol: true}
      if(AppModule.session.products[0].price.currency == "USD") return {}
    }
    return {}
  }
}

export default abstract class Content extends ContentPrice {
    abstract toggleFooterButton(state:boolean):void
    
    get sessionAssets(){
      return AppModule.session.assets
    }

    initAssets() {
    if(AppModule.session.sessionId && this.sessionAssets && this.sessionAssets.length > 0) {
      let assetApi = new AssetApi(new RestConfiguration({ basePath: '/rest'}))
      let assets: AssetFile[] = []
      for(let i = 0; i < this.sessionAssets.length; i++) {
        let getAssetRequest = {'sessionId': AppModule.session.sessionId, 'assetId': ''+this.sessionAssets[i]}
        assetApi.getAsset(getAssetRequest).then(
                (value) => {
                    let asset: AssetFile = new AssetFile(value.url!, value.width!, value.height!)
                    asset.assetId = value.assetId
                    asset.id = i
                    assets.push(asset)
                },
                (reason) => {
                    window.console.log(reason)
                });
      }
      AssetsModule.SetAssets(assets)
    }
  }
}
